<template>
<div>
  <v-container v-if="withWrapper" pa-5 pa-sm-10 pa-lg-5>
    <slot></slot>
  </v-container>
  <div v-else>
    <slot></slot>
  </div>
</div>
</template>

<script>
export default {
  props: {
    withWrapper: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style>

</style>
